module.exports = __webpack_public_path__ + "img/gb9115_17_a.prt.7206adc6.jpg";